import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "pa-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "2" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn_primary, {
            onClick: _ctx.editTaxFrom,
            block: ""
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode("Ajouter")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "10" }),
      _createVNode(_component_v_col, { cols: "12" }, {
        default: _withCtx(() => [
          _createVNode(_component_oss_data_table, {
            headers: _ctx.headers,
            items: _ctx.declarationForms,
            striped: true,
            "table-hover": true,
            dense: true,
            onClickRow: _cache[0] || (_cache[0] = ($event: any) => (_ctx.editTaxFrom($event)))
          }, {
            "item.status": _withCtx(({ item }) => [
              _createVNode(_component_v_chip, {
                class: "ma-2",
                "large-chip": "",
                filter: "",
                link: "",
                color: _ctx.getColor(item.status),
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.declarationStatus[item.status]), 1)
                ]),
                _: 2
              }, 1032, ["color"])
            ]),
            "item.actions": _withCtx(({ item }) => [
              _createVNode(_component_v_menu, { "offset-y": "" }, {
                activator: _withCtx(({ props }) => [
                  _createVNode(_component_v_btn_icon, _mergeProps({ icon: "$dots_vertical" }, props), null, 16)
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_v_list, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item, {
                        onClick: _withModifiers(($event: any) => (_ctx.editTaxFrom(item)), ["stop"])
                      }, {
                        append: _withCtx(() => [
                          _createVNode(_component_v_icon, { size: "small" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                              _createTextVNode("$oss-edit")
                            ])),
                            _: 1
                          })
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                              _createTextVNode("Editer")
                            ])),
                            _: 1
                          })
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["headers", "items"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}